/** React imports */
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

/** Images */

/** MUI icons */

/** MUI imports */
import { Box, Typography, Grid, Divider } from "@mui/material";
import { styled } from "@mui/material/styles";

/** Global variables */
const PREFIX = "PricingAcc";

const classes = {
    body2: `${PREFIX}-body2`,
    serviceName: `${PREFIX}-serviceName`,
    subName: `${PREFIX}-subName`,
    serviceBody: `${PREFIX}-serviceBody`,
    subInfo: `${PREFIX}-subInfo`,
    roundBack: `${PREFIX}-roundBack`,
    roundBack2: `${PREFIX}-roundBack2`,
    roundBack3: `${PREFIX}-roundBack3`,
    months: `${PREFIX}-months`,
    monthsText1: `${PREFIX}-monthsText1`,
    monthsText2: `${PREFIX}-monthsText2`,
    body3: `${PREFIX}-body3`,
    textFoot: `${PREFIX}-textFoot`,
};

const StyledContainer = styled(Box)(({ theme }) => ({
    [`& .${classes.serviceName}`]: {
        fontSize: 22,
        marginBottom: 10,
    },

    [`& .${classes.subName}`]: {
        fontSize: 12,
        marginBottom: 10,
    },

    [`& .${classes.body2}`]: {
        backgroundColor: "white",
        marginTop: 15,
        padding: 30,
        minHeight: 850,
    },

    [`& .${classes.body3}`]: {
        padding: 30,
    },

    [`& .${classes.textFoot}`]: {
        padding: "15px 30px",
    },

    [`& .${classes.serviceBody}`]: {
        backgroundColor: "#F8F9F8",
        marginTop: 30,
        padding: 30,
        borderRadius: 30,
        overflow: "auto",
    },

    [`& .${classes.subInfo}`]: {
        marginTop: 30,
        fontSize: 12,
    },

    [`& .${classes.roundBack}`]: {
        backgroundColor: "#6D70AD",
        minWidth: "125px",
        marginRight: "-27px",
        justifyContent: "center",
        display: "flex",
    },

    [`& .${classes.roundBack2}`]: {
        backgroundColor: "#2D348B",
        minWidth: "130px",
        justifyContent: "center",
        display: "flex",
    },
    [`& .${classes.roundBack3}`]: {
        color: "#031851",
        minWidth: "115px",
        marginRight: "-25px",
        justifyContent: "center",
        display: "flex",
    },
    [`& .${classes.months}`]: {
        fontSize: 16,
    },
    [`& .${classes.monthsText1}`]: {
        fontSize: 16,
        justifyContent: "center",
        display: "flex",
    },
    [`& .${classes.monthsText2}`]: {
        fontSize: 16,
        justifyContent: "center",
        display: "flex",
        marginRight: "-25px",
    },
}));

// Función para convertir primera letra en mayúscula
function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const PricingAcc = (props) => {
    /** Internationalization i18n */
    const [t] = useTranslation("global");

    /** React redux */
    const todos = useSelector((state) => state.todos);

    const { pricingAcc } = props;

    const getNamesAdd = (values) => {
        let name = "";
        if (values.additional_name === "Checks") {
            name = t("proposals.checks");
        } else if (values.additional_name === "A/R reconciliation") {
            name = t("proposals.addAR");
        } else if (values.additional_name === "A/P reconciliation") {
            name = t("proposals.addAP");
        } else if (values.additional_name === "Classes/Categories accounting") {
            name = t("services.classesCategories");
        } else if (values.additional_name === "Multi-entity accounting") {
            name = t("proposals.multiEntity");
        } else if (values.additional_name === "Ordinario") {
            name = t("proposals.addOrdTax");
        } else if (values.additional_name === "Especial") {
            name = t("proposals.addSpecial");
        } else if (values.additional_name === "Municipal") {
            name = t("proposals.addImpMun");
        } else if (values.additional_name === "Personalized reporting") {
            name = t("proposals.addPerRep");
        } else if (values.additional_name === "Sales taxes") {
            name = t("proposals.addSales");
        } else if (values.additional_name === "OthersAcc") {
            name = values.other_name;
        } else {
            name = values.additional_name;
        }

        return name;
    };

    return (
        <StyledContainer>
            {pricingAcc.onboarding.isActive && (
                <Grid
                    container
                    alignItems="center"
                    justifyContent="space-between"
                    spacing={2}
                    sx={{ paddingBottom: 1.5, paddingTop: 1.5 }}
                >
                    <Grid item xs={3}>
                        <Typography variant="h4">{t("proposals.onboard")}</Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <Typography variant="body1" sx={{ textAlign: "center" }}>
                            {t(`proposals.oneTime2`)}
                        </Typography>
                    </Grid>
                    <Grid item xs={1} sx={{ textAlign: "center" }}>
                        <Typography variant="body1">1</Typography>
                    </Grid>
                    <Grid item xs={1} sx={{ textAlign: "right" }}>
                        <Typography variant="body1">
                            $
                            {
                            pricingAcc?.prospect?.prospect_id === "66bcba001a7779f7a5c17170" ? 
                            parseFloat(2000).toLocaleString(todos.amountFormat, {
                                maximumFractionDigits: 2,
                            })
                            : 
                            parseFloat(pricingAcc.onboarding.fee).toLocaleString(todos.amountFormat, {
                                maximumFractionDigits: 2,
                            })}
                        </Typography>
                    </Grid>
                    <Grid item xs={2} sx={{ textAlign: "right" }}>
                        <Typography variant="body1">
                            $
                            {
                            pricingAcc?.prospect?.prospect_id === "66bcba001a7779f7a5c17170" ? 
                            parseFloat(2000).toLocaleString(todos.amountFormat, {
                                maximumFractionDigits: 2,
                            })
                            : 
                            parseFloat(pricingAcc.onboarding.fee).toLocaleString(todos.amountFormat, {
                                maximumFractionDigits: 2,
                            })}
                        </Typography>
                    </Grid>
                    <Grid item xs={1} sx={{ textAlign: "center" }}>
                        <Typography variant="body1">
                            {parseFloat(pricingAcc.onboarding.discount).toLocaleString(todos.amountFormat, {
                                maximumFractionDigits: 2,
                            })}
                            %
                        </Typography>
                    </Grid>
                    <Grid item xs={2} sx={{ textAlign: "right" }}>
                        <Typography variant="body1">
                            $
                            {
                            pricingAcc?.prospect?.prospect_id === "66bcba001a7779f7a5c17170" ? 
                            parseFloat(
                                2000 * (1 - pricingAcc.onboarding.discount / 100)
                            ).toLocaleString(todos.amountFormat, {
                                maximumFractionDigits: 2,
                            })
                            : 
                            parseFloat(
                                pricingAcc.onboarding.fee * (1 - pricingAcc.onboarding.discount / 100)
                            ).toLocaleString(todos.amountFormat, {
                                maximumFractionDigits: 2,
                            })}
                        </Typography>
                    </Grid>
                </Grid>
            )}
            {pricingAcc.recurring.isActive && (
                <>
                    <Divider
                        sx={{
                            backgroundColor: "#031851",
                        }}
                    />
                    <Grid
                        container
                        alignItems="center"
                        justifyContent="space-between"
                        spacing={2}
                        sx={{ paddingBottom: 1.5, paddingTop: 1.5 }}
                    >
                        <Grid item xs={3}>
                            <Typography variant="h4">
                                {t("proposals.recurring") +
                                    ` (${capitalize(
                                        pricingAcc.recurring.initDate.locale(t("language.locale")).format("MMM YYYY")
                                    ).replace(/\./g, "")})`}
                            </Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography variant="body1" sx={{ textAlign: "center" }}>
                                {pricingAcc.recurring.payAnnually
                                    ? t(`proposals.oneTime2`)
                                    : t("miscellaneous.monthly")}
                            </Typography>
                        </Grid>
                        <Grid item xs={1} sx={{ textAlign: "center" }}>
                            <Typography variant="body1">
                                {pricingAcc.recurring.additionals.length > 0 && !pricingAcc.recurring.onlyAdd
                                    ? "-"
                                    : pricingAcc.recurring.payAnnually
                                    ? 12
                                    : 
                                    (
                                        pricingAcc?.prospect?.prospect_id === "66bcba001a7779f7a5c17170" ? 
                                        1
                                        :
                                        pricingAcc.recurring.qty
                                    )}
                            </Typography>
                        </Grid>
                        <Grid item xs={1} sx={{ textAlign: "right" }}>
                            <Typography variant="body1">
                                {pricingAcc.recurring.additionals.length > 0 && !pricingAcc.recurring.onlyAdd
                                    ? "-"
                                    : "$" +
                                    (
                                        pricingAcc?.prospect?.prospect_id === "66bcba001a7779f7a5c17170" ? 
                                        parseFloat(2500).toLocaleString(todos.amountFormat, {
                                            maximumFractionDigits: 2,
                                        })
                                        :
                                        parseFloat(pricingAcc.recurring.fee).toLocaleString(todos.amountFormat, {
                                            maximumFractionDigits: 2,
                                        })
                                    )
                                }
                            </Typography>
                        </Grid>
                        <Grid item xs={2} sx={{ textAlign: "right" }}>
                            <Typography variant="body1">
                                {pricingAcc.recurring.additionals.length > 0 && !pricingAcc.recurring.onlyAdd
                                    ? "-"
                                    : "$" +
                                      parseFloat(
                                          pricingAcc.recurring.payAnnually
                                              ? pricingAcc.recurring.fee * 12
                                              : pricingAcc.recurring.fee * pricingAcc.recurring.qty
                                      ).toLocaleString(todos.amountFormat, {
                                          maximumFractionDigits: 2,
                                      })}
                            </Typography>
                        </Grid>
                        <Grid item xs={1} sx={{ textAlign: "center" }}>
                            <Typography variant="body1">
                                {pricingAcc.recurring.additionals.length > 0 && !pricingAcc.recurring.onlyAdd
                                    ? "-"
                                    : parseFloat(pricingAcc.recurring.discount).toLocaleString(todos.amountFormat, {
                                          maximumFractionDigits: 2,
                                      }) + "%"}
                            </Typography>
                        </Grid>
                        <Grid item xs={2} sx={{ textAlign: "right" }}>
                            <Typography variant="body1">
                                $
                                {parseFloat(
                                    (pricingAcc.recurring.payAnnually
                                        ? pricingAcc.recurring.fee * 12 +
                                          pricingAcc.recurring.recuHours * pricingAcc.recurring.addFee
                                        : pricingAcc.recurring.fee * pricingAcc.recurring.qty +
                                          pricingAcc.recurring.recuHours * pricingAcc.recurring.addFee) *
                                        (1 - pricingAcc.recurring.discount / 100)
                                ).toLocaleString(todos.amountFormat, {
                                    maximumFractionDigits: 2,
                                })}
                            </Typography>
                        </Grid>
                    </Grid>
                    {pricingAcc.recurring.additionals.length > 0 && !pricingAcc.recurring.onlyAdd && (
                        <>
                            <Divider
                                sx={{
                                    backgroundColor: "#031851",
                                }}
                            />
                            <Grid
                                container
                                alignItems="center"
                                justifyContent="space-between"
                                spacing={2}
                                sx={{ paddingBottom: 1.5, paddingTop: 1.5 }}
                            >
                                <Grid item xs={3}>
                                    <Typography variant="body1" sx={{ paddingLeft: 6, wordBreak: "break-word" }}>
                                        {t("proposals.coreServ")}
                                    </Typography>
                                </Grid>
                                <Grid item xs={2}></Grid>
                                <Grid item xs={1} sx={{ textAlign: "center" }}>
                                    <Typography variant="body1">
                                        {pricingAcc.recurring.payAnnually ? 12 : pricingAcc.recurring.qty}
                                    </Typography>
                                </Grid>
                                <Grid item xs={1} sx={{ textAlign: "right" }}>
                                    <Typography variant="body1">
                                        $
                                        {parseFloat(pricingAcc.recurring.fee).toLocaleString(todos.amountFormat, {
                                            maximumFractionDigits: 2,
                                        })}
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} sx={{ textAlign: "right" }}>
                                    <Typography variant="body1">
                                        $
                                        {parseFloat(
                                            pricingAcc.recurring.payAnnually
                                                ? pricingAcc.recurring.fee * 12
                                                : pricingAcc.recurring.fee * pricingAcc.recurring.qty
                                        ).toLocaleString(todos.amountFormat, {
                                            maximumFractionDigits: 2,
                                        })}
                                    </Typography>
                                </Grid>
                                <Grid item xs={1} sx={{ textAlign: "center" }}>
                                    <Typography variant="body1">
                                        {parseFloat(pricingAcc.recurring.discount).toLocaleString(todos.amountFormat, {
                                            maximumFractionDigits: 2,
                                        })}
                                        %
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} sx={{ textAlign: "right" }}>
                                    <Typography variant="body1">
                                        $
                                        {parseFloat(
                                            (pricingAcc.recurring.payAnnually
                                                ? pricingAcc.recurring.fee * 12
                                                : pricingAcc.recurring.fee * pricingAcc.recurring.qty) *
                                                (1 - pricingAcc.recurring.discount / 100)
                                        ).toLocaleString(todos.amountFormat, {
                                            maximumFractionDigits: 2,
                                        })}
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Divider
                                sx={{
                                    backgroundColor: "#031851",
                                }}
                            />
                            <Grid
                                container
                                alignItems="center"
                                justifyContent="space-between"
                                spacing={2}
                                sx={{ paddingBottom: 1.5, paddingTop: 1.5 }}
                            >
                                <Grid item xs={3}>
                                    <Typography variant="body1" sx={{ paddingLeft: 6, wordBreak: "break-word" }}>
                                        {t("proposals.addons")}
                                    </Typography>
                                </Grid>
                                <Grid item xs={2}></Grid>
                                <Grid item xs={1} sx={{ textAlign: "center" }}>
                                    <Typography variant="body1">{pricingAcc.recurring.recuHours}</Typography>
                                </Grid>
                                <Grid item xs={1} sx={{ textAlign: "right" }}>
                                    <Typography variant="body1">
                                        $
                                        {parseFloat(pricingAcc.recurring.addFee).toLocaleString(todos.amountFormat, {
                                            maximumFractionDigits: 2,
                                        })}
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} sx={{ textAlign: "right" }}>
                                    <Typography variant="body1">
                                        $
                                        {parseFloat(
                                            pricingAcc.recurring.recuHours * pricingAcc.recurring.addFee
                                        ).toLocaleString(todos.amountFormat, {
                                            maximumFractionDigits: 2,
                                        })}
                                    </Typography>
                                </Grid>
                                <Grid item xs={1} sx={{ textAlign: "center" }}>
                                    <Typography variant="body1">
                                        {parseFloat(pricingAcc.recurring.discount).toLocaleString(todos.amountFormat, {
                                            maximumFractionDigits: 2,
                                        })}
                                        %
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} sx={{ textAlign: "right" }}>
                                    <Typography variant="body1">
                                        $
                                        {parseFloat(
                                            pricingAcc.recurring.recuHours *
                                                pricingAcc.recurring.addFee *
                                                (1 - pricingAcc.recurring.discount / 100)
                                        ).toLocaleString(todos.amountFormat, {
                                            maximumFractionDigits: 2,
                                        })}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </>
                    )}
                    {pricingAcc.recurring.additionals.map(
                        (value) =>
                            value.additional_name !== "Accountant" && (
                                <>
                                    <Divider
                                        sx={{
                                            backgroundColor: "#031851",
                                        }}
                                    />
                                    <Grid
                                        container
                                        alignItems="center"
                                        justifyContent="space-between"
                                        spacing={2}
                                        sx={{ paddingBottom: 1, paddingTop: 1 }}
                                    >
                                        <Grid item xs={3}>
                                            <Typography
                                                variant="body1"
                                                sx={{ paddingLeft: 8, wordBreak: "break-word" }}
                                            >
                                                {value.other_name ?? getNamesAdd(value)}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={2}></Grid>
                                        <Grid item xs={1} sx={{ textAlign: "center" }}>
                                            <Typography variant="body1">{value.hours}</Typography>
                                        </Grid>
                                        <Grid item xs={1} sx={{ textAlign: "right" }}>
                                            <Typography variant="body1">
                                                $
                                                {parseFloat(pricingAcc.recurring.addFee).toLocaleString(
                                                    todos.amountFormat,
                                                    {
                                                        maximumFractionDigits: 2,
                                                    }
                                                )}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={2} sx={{ textAlign: "right" }}>
                                            <Typography variant="body1">
                                                $
                                                {parseFloat(pricingAcc.recurring.addFee * value.hours).toLocaleString(
                                                    todos.amountFormat,
                                                    {
                                                        maximumFractionDigits: 2,
                                                    }
                                                )}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={1} sx={{ textAlign: "center" }}>
                                            <Typography variant="body1">
                                                {parseFloat(pricingAcc.recurring.discount).toLocaleString(
                                                    todos.amountFormat,
                                                    {
                                                        maximumFractionDigits: 2,
                                                    }
                                                )}
                                                %
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={2} sx={{ textAlign: "right" }}>
                                            <Typography variant="body1">
                                                $
                                                {parseFloat(
                                                    pricingAcc.recurring.addFee *
                                                        value.hours *
                                                        (1 - pricingAcc.recurring.discount / 100)
                                                ).toLocaleString(todos.amountFormat, {
                                                    maximumFractionDigits: 2,
                                                })}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </>
                            )
                    )}
                </>
            )}
            {pricingAcc.cleanUp.isActive && (
                <>
                    <Divider
                        sx={{
                            backgroundColor: "#031851",
                        }}
                    />
                    <Grid
                        container
                        alignItems="center"
                        justifyContent="space-between"
                        spacing={2}
                        sx={{ paddingBottom: 1.5, paddingTop: 1.5 }}
                    >
                        <Grid item xs={3}>
                            <Typography variant="h4">
                                {t("invoicing.cleanUp") +
                                    ` (${
                                        capitalize(
                                            pricingAcc.cleanUp.initDate.locale(t("language.locale")).format("MMM")
                                        ).replace(/\./g, "") +
                                        "-" +
                                        capitalize(
                                            pricingAcc.cleanUp.untilDate.locale(t("language.locale")).format("MMM YYYY")
                                        ).replace(/\./g, "")
                                    })`}
                            </Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography variant="body1" sx={{ textAlign: "center" }}>
                                {t("proposals.oneTime2")}
                            </Typography>
                        </Grid>
                        <Grid item xs={1} sx={{ textAlign: "center" }}>
                            <Typography variant="body1">
                                {pricingAcc.cleanUp.additionals.length > 0 && !pricingAcc.cleanUp.onlyAdd
                                    ? "-"
                                    : pricingAcc.cleanUp.monthQty}
                            </Typography>
                        </Grid>
                        <Grid item xs={1} sx={{ textAlign: "right" }}>
                            <Typography variant="body1">
                                {pricingAcc.cleanUp.additionals.length > 0 && !pricingAcc.cleanUp.onlyAdd
                                    ? "-"
                                    : "$" +
                                      parseFloat(pricingAcc.cleanUp.fee).toLocaleString(todos.amountFormat, {
                                          maximumFractionDigits: 2,
                                      })}
                            </Typography>
                        </Grid>
                        <Grid item xs={2} sx={{ textAlign: "right" }}>
                            <Typography variant="body1">
                                {pricingAcc.cleanUp.additionals.length > 0 && !pricingAcc.cleanUp.onlyAdd
                                    ? "-"
                                    : "$" +
                                      parseFloat(pricingAcc.cleanUp.fee * pricingAcc.cleanUp.monthQty).toLocaleString(
                                          todos.amountFormat,
                                          {
                                              maximumFractionDigits: 2,
                                          }
                                      )}
                            </Typography>
                        </Grid>
                        <Grid item xs={1} sx={{ textAlign: "center" }}>
                            <Typography variant="body1">
                                {pricingAcc.cleanUp.additionals.length > 0 && !pricingAcc.cleanUp.onlyAdd
                                    ? "-"
                                    : parseFloat(pricingAcc.cleanUp.discount).toLocaleString(todos.amountFormat, {
                                          maximumFractionDigits: 2,
                                      }) + "%"}
                            </Typography>
                        </Grid>
                        <Grid item xs={2} sx={{ textAlign: "right" }}>
                            <Typography variant="body1">
                                $
                                {parseFloat(
                                    (pricingAcc.cleanUp.fee * pricingAcc.cleanUp.monthQty +
                                        pricingAcc.cleanUp.totalHours * pricingAcc.cleanUp.addFee) *
                                        (1 - pricingAcc.cleanUp.discount / 100)
                                ).toLocaleString(todos.amountFormat, {
                                    maximumFractionDigits: 2,
                                })}
                            </Typography>
                        </Grid>
                    </Grid>
                    {pricingAcc.cleanUp.additionals.length > 0 && !pricingAcc.cleanUp.onlyAdd && (
                        <>
                            <Divider
                                sx={{
                                    backgroundColor: "#031851",
                                }}
                            />
                            <Grid
                                container
                                alignItems="center"
                                justifyContent="space-between"
                                spacing={2}
                                sx={{ paddingBottom: 1.5, paddingTop: 1.5 }}
                            >
                                <Grid item xs={3}>
                                    <Typography variant="body1" sx={{ paddingLeft: 6, wordBreak: "break-word" }}>
                                        {t("proposals.coreServ")}
                                    </Typography>
                                </Grid>
                                <Grid item xs={2}></Grid>
                                <Grid item xs={1} sx={{ textAlign: "center" }}>
                                    <Typography variant="body1">{pricingAcc.cleanUp.monthQty}</Typography>
                                </Grid>
                                <Grid item xs={1} sx={{ textAlign: "right" }}>
                                    <Typography variant="body1">
                                        $
                                        {parseFloat(pricingAcc.cleanUp.fee).toLocaleString(todos.amountFormat, {
                                            maximumFractionDigits: 2,
                                        })}
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} sx={{ textAlign: "right" }}>
                                    <Typography variant="body1">
                                        $
                                        {parseFloat(
                                            pricingAcc.cleanUp.fee * pricingAcc.cleanUp.monthQty
                                        ).toLocaleString(todos.amountFormat, {
                                            maximumFractionDigits: 2,
                                        })}
                                    </Typography>
                                </Grid>
                                <Grid item xs={1} sx={{ textAlign: "center" }}>
                                    <Typography variant="body1">
                                        {parseFloat(pricingAcc.cleanUp.discount).toLocaleString(todos.amountFormat, {
                                            maximumFractionDigits: 2,
                                        })}
                                        %
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} sx={{ textAlign: "right" }}>
                                    <Typography variant="body1">
                                        $
                                        {parseFloat(
                                            pricingAcc.cleanUp.fee *
                                                pricingAcc.cleanUp.monthQty *
                                                (1 - pricingAcc.cleanUp.discount / 100)
                                        ).toLocaleString(todos.amountFormat, {
                                            maximumFractionDigits: 2,
                                        })}
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Divider
                                sx={{
                                    backgroundColor: "#031851",
                                }}
                            />
                            <Grid
                                container
                                alignItems="center"
                                justifyContent="space-between"
                                spacing={2}
                                sx={{ paddingBottom: 1.5, paddingTop: 1.5 }}
                            >
                                <Grid item xs={3}>
                                    <Typography variant="body1" sx={{ paddingLeft: 6, wordBreak: "break-word" }}>
                                        {t("proposals.addons")}
                                    </Typography>
                                </Grid>
                                <Grid item xs={2}></Grid>
                                <Grid item xs={1} sx={{ textAlign: "center" }}>
                                    <Typography variant="body1">{pricingAcc.cleanUp.totalHours}</Typography>
                                </Grid>
                                <Grid item xs={1} sx={{ textAlign: "right" }}>
                                    <Typography variant="body1">
                                        $
                                        {parseFloat(pricingAcc.cleanUp.addFee).toLocaleString(todos.amountFormat, {
                                            maximumFractionDigits: 2,
                                        })}
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} sx={{ textAlign: "right" }}>
                                    <Typography variant="body1">
                                        $
                                        {parseFloat(
                                            pricingAcc.cleanUp.totalHours * pricingAcc.cleanUp.addFee
                                        ).toLocaleString(todos.amountFormat, {
                                            maximumFractionDigits: 2,
                                        })}
                                    </Typography>
                                </Grid>
                                <Grid item xs={1} sx={{ textAlign: "center" }}>
                                    <Typography variant="body1">
                                        {parseFloat(pricingAcc.cleanUp.discount).toLocaleString(todos.amountFormat, {
                                            maximumFractionDigits: 2,
                                        })}
                                        %
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} sx={{ textAlign: "right" }}>
                                    <Typography variant="body1">
                                        $
                                        {parseFloat(
                                            pricingAcc.cleanUp.totalHours *
                                                pricingAcc.cleanUp.addFee *
                                                (1 - pricingAcc.cleanUp.discount / 100)
                                        ).toLocaleString(todos.amountFormat, {
                                            maximumFractionDigits: 2,
                                        })}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </>
                    )}
                    {pricingAcc.cleanUp.additionals.map(
                        (value) =>
                            value.additional_name !== "Accountant" && (
                                <>
                                    <Divider
                                        sx={{
                                            backgroundColor: "#031851",
                                        }}
                                    />
                                    <Grid
                                        container
                                        alignItems="center"
                                        justifyContent="space-between"
                                        spacing={2}
                                        sx={{ paddingBottom: 1, paddingTop: 1 }}
                                    >
                                        <Grid item xs={3}>
                                            <Typography
                                                variant="body1"
                                                sx={{ paddingLeft: 8, wordBreak: "break-word" }}
                                            >
                                                {value.other_name ?? getNamesAdd(value)}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={2}></Grid>
                                        <Grid item xs={1} sx={{ textAlign: "center" }}>
                                            <Typography variant="body1">{value.hours}</Typography>
                                        </Grid>
                                        <Grid item xs={1} sx={{ textAlign: "right" }}>
                                            <Typography variant="body1">
                                                $
                                                {parseFloat(pricingAcc.cleanUp.addFee).toLocaleString(
                                                    todos.amountFormat,
                                                    {
                                                        maximumFractionDigits: 2,
                                                    }
                                                )}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={2} sx={{ textAlign: "right" }}>
                                            <Typography variant="body1">
                                                $
                                                {parseFloat(pricingAcc.cleanUp.addFee * value.hours).toLocaleString(
                                                    todos.amountFormat,
                                                    {
                                                        maximumFractionDigits: 2,
                                                    }
                                                )}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={1} sx={{ textAlign: "center" }}>
                                            <Typography variant="body1">
                                                {parseFloat(pricingAcc.cleanUp.discount).toLocaleString(
                                                    todos.amountFormat,
                                                    {
                                                        maximumFractionDigits: 2,
                                                    }
                                                )}
                                                %
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={2} sx={{ textAlign: "right" }}>
                                            <Typography variant="body1">
                                                $
                                                {parseFloat(
                                                    pricingAcc.cleanUp.addFee *
                                                        value.hours *
                                                        (1 - pricingAcc.cleanUp.discount / 100)
                                                ).toLocaleString(todos.amountFormat, {
                                                    maximumFractionDigits: 2,
                                                })}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </>
                            )
                    )}
                </>
            )}
            {pricingAcc.catchUp.isActive && (
                <>
                    <Divider
                        sx={{
                            backgroundColor: "#031851",
                        }}
                    />
                    <Grid
                        container
                        alignItems="center"
                        justifyContent="space-between"
                        spacing={2}
                        sx={{ paddingBottom: 1.5, paddingTop: 1.5 }}
                    >
                        <Grid item xs={3}>
                            <Typography variant="h4">
                                {t("invoicing.catchUp") +
                                    ` (${
                                        capitalize(
                                            pricingAcc.catchUp.initDate.locale(t("language.locale")).format("MMM")
                                        ).replace(/\./g, "") +
                                        "-" +
                                        capitalize(
                                            pricingAcc.catchUp.untilDate.locale(t("language.locale")).format("MMM YYYY")
                                        ).replace(/\./g, "")
                                    })`}
                            </Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography variant="body1" sx={{ textAlign: "center" }}>
                                {t("proposals.oneTime2")}
                            </Typography>
                        </Grid>
                        <Grid item xs={1} sx={{ textAlign: "center" }}>
                            <Typography variant="body1">
                                {pricingAcc.catchUp.additionals.length > 0 && !pricingAcc.catchUp.onlyAdd
                                    ? "-"
                                    : pricingAcc.catchUp.monthQty}
                            </Typography>
                        </Grid>
                        <Grid item xs={1} sx={{ textAlign: "right" }}>
                            <Typography variant="body1">
                                {pricingAcc.catchUp.additionals.length > 0 && !pricingAcc.catchUp.onlyAdd
                                    ? "-"
                                    : "$" +
                                      parseFloat(pricingAcc.catchUp.fee).toLocaleString(todos.amountFormat, {
                                          maximumFractionDigits: 2,
                                      })}
                            </Typography>
                        </Grid>
                        <Grid item xs={2} sx={{ textAlign: "right" }}>
                            <Typography variant="body1">
                                {pricingAcc.catchUp.additionals.length > 0 && !pricingAcc.catchUp.onlyAdd
                                    ? "-"
                                    : "$" +
                                      parseFloat(pricingAcc.catchUp.fee * pricingAcc.catchUp.monthQty).toLocaleString(
                                          todos.amountFormat,
                                          {
                                              maximumFractionDigits: 2,
                                          }
                                      )}
                            </Typography>
                        </Grid>
                        <Grid item xs={1} sx={{ textAlign: "center" }}>
                            <Typography variant="body1">
                                {pricingAcc.catchUp.additionals.length > 0 && !pricingAcc.catchUp.onlyAdd
                                    ? "-"
                                    : parseFloat(pricingAcc.catchUp.discount).toLocaleString(todos.amountFormat, {
                                          maximumFractionDigits: 2,
                                      }) + "%"}
                            </Typography>
                        </Grid>
                        <Grid item xs={2} sx={{ textAlign: "right" }}>
                            <Typography variant="body1">
                                $
                                {parseFloat(
                                    (pricingAcc.catchUp.fee * pricingAcc.catchUp.monthQty +
                                        pricingAcc.catchUp.totalHours * pricingAcc.catchUp.addFee) *
                                        (1 - pricingAcc.catchUp.discount / 100)
                                ).toLocaleString(todos.amountFormat, {
                                    maximumFractionDigits: 2,
                                })}
                            </Typography>
                        </Grid>
                    </Grid>
                    {pricingAcc.catchUp.additionals.length > 0 && !pricingAcc.catchUp.onlyAdd && (
                        <>
                            <Divider
                                sx={{
                                    backgroundColor: "#031851",
                                }}
                            />
                            <Grid
                                container
                                alignItems="center"
                                justifyContent="space-between"
                                spacing={2}
                                sx={{ paddingBottom: 1.5, paddingTop: 1.5 }}
                            >
                                <Grid item xs={3}>
                                    <Typography variant="body1" sx={{ paddingLeft: 6, wordBreak: "break-word" }}>
                                        {t("proposals.coreServ")}
                                    </Typography>
                                </Grid>
                                <Grid item xs={2}></Grid>
                                <Grid item xs={1} sx={{ textAlign: "center" }}>
                                    <Typography variant="body1">{pricingAcc.catchUp.monthQty}</Typography>
                                </Grid>
                                <Grid item xs={1} sx={{ textAlign: "right" }}>
                                    <Typography variant="body1">
                                        $
                                        {parseFloat(pricingAcc.catchUp.fee).toLocaleString(todos.amountFormat, {
                                            maximumFractionDigits: 2,
                                        })}
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} sx={{ textAlign: "right" }}>
                                    <Typography variant="body1">
                                        $
                                        {parseFloat(
                                            pricingAcc.catchUp.fee * pricingAcc.catchUp.monthQty
                                        ).toLocaleString(todos.amountFormat, {
                                            maximumFractionDigits: 2,
                                        })}
                                    </Typography>
                                </Grid>
                                <Grid item xs={1} sx={{ textAlign: "center" }}>
                                    <Typography variant="body1">
                                        {parseFloat(pricingAcc.catchUp.discount).toLocaleString(todos.amountFormat, {
                                            maximumFractionDigits: 2,
                                        })}
                                        %
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} sx={{ textAlign: "right" }}>
                                    <Typography variant="body1">
                                        $
                                        {parseFloat(
                                            pricingAcc.catchUp.fee *
                                                pricingAcc.catchUp.monthQty *
                                                (1 - pricingAcc.catchUp.discount / 100)
                                        ).toLocaleString(todos.amountFormat, {
                                            maximumFractionDigits: 2,
                                        })}
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Divider
                                sx={{
                                    backgroundColor: "#031851",
                                }}
                            />
                            <Grid
                                container
                                alignItems="center"
                                justifyContent="space-between"
                                spacing={2}
                                sx={{ paddingBottom: 1.5, paddingTop: 1.5 }}
                            >
                                <Grid item xs={3}>
                                    <Typography variant="body1" sx={{ paddingLeft: 6, wordBreak: "break-word" }}>
                                        {t("proposals.addons")}
                                    </Typography>
                                </Grid>
                                <Grid item xs={2}></Grid>
                                <Grid item xs={1} sx={{ textAlign: "center" }}>
                                    <Typography variant="body1">{pricingAcc.catchUp.totalHours}</Typography>
                                </Grid>
                                <Grid item xs={1} sx={{ textAlign: "right" }}>
                                    <Typography variant="body1">
                                        $
                                        {parseFloat(pricingAcc.catchUp.addFee).toLocaleString(todos.amountFormat, {
                                            maximumFractionDigits: 2,
                                        })}
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} sx={{ textAlign: "right" }}>
                                    <Typography variant="body1">
                                        $
                                        {parseFloat(
                                            pricingAcc.catchUp.totalHours * pricingAcc.catchUp.addFee
                                        ).toLocaleString(todos.amountFormat, {
                                            maximumFractionDigits: 2,
                                        })}
                                    </Typography>
                                </Grid>
                                <Grid item xs={1} sx={{ textAlign: "center" }}>
                                    <Typography variant="body1">
                                        {parseFloat(pricingAcc.catchUp.discount).toLocaleString(todos.amountFormat, {
                                            maximumFractionDigits: 2,
                                        })}
                                        %
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} sx={{ textAlign: "right" }}>
                                    <Typography variant="body1">
                                        $
                                        {parseFloat(
                                            pricingAcc.catchUp.totalHours *
                                                pricingAcc.catchUp.addFee *
                                                (1 - pricingAcc.catchUp.discount / 100)
                                        ).toLocaleString(todos.amountFormat, {
                                            maximumFractionDigits: 2,
                                        })}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </>
                    )}
                    {pricingAcc.catchUp.additionals.map(
                        (value) =>
                            value.additional_name !== "Accountant" && (
                                <>
                                    <Divider
                                        sx={{
                                            backgroundColor: "#031851",
                                        }}
                                    />
                                    <Grid
                                        container
                                        alignItems="center"
                                        justifyContent="space-between"
                                        spacing={2}
                                        sx={{ paddingBottom: 1, paddingTop: 1 }}
                                    >
                                        <Grid item xs={3}>
                                            <Typography
                                                variant="body1"
                                                sx={{ paddingLeft: 8, wordBreak: "break-word" }}
                                            >
                                                {value.other_name ?? getNamesAdd(value)}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={2}></Grid>
                                        <Grid item xs={1} sx={{ textAlign: "center" }}>
                                            <Typography variant="body1">{value.hours}</Typography>
                                        </Grid>
                                        <Grid item xs={1} sx={{ textAlign: "right" }}>
                                            <Typography variant="body1">
                                                $
                                                {parseFloat(pricingAcc.catchUp.addFee).toLocaleString(
                                                    todos.amountFormat,
                                                    {
                                                        maximumFractionDigits: 2,
                                                    }
                                                )}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={2} sx={{ textAlign: "right" }}>
                                            <Typography variant="body1">
                                                $
                                                {parseFloat(pricingAcc.catchUp.addFee * value.hours).toLocaleString(
                                                    todos.amountFormat,
                                                    {
                                                        maximumFractionDigits: 2,
                                                    }
                                                )}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={1} sx={{ textAlign: "center" }}>
                                            <Typography variant="body1">{pricingAcc.catchUp.discount}%</Typography>
                                        </Grid>
                                        <Grid item xs={2} sx={{ textAlign: "right" }}>
                                            <Typography variant="body1">
                                                $
                                                {parseFloat(
                                                    pricingAcc.catchUp.addFee *
                                                        value.hours *
                                                        (1 - pricingAcc.catchUp.discount / 100)
                                                ).toLocaleString(todos.amountFormat, {
                                                    maximumFractionDigits: 2,
                                                })}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </>
                            )
                    )}
                </>
            )}
            {pricingAcc.consulting.isActive &&
                pricingAcc.consulting.array.map((consult) => (
                    <>
                        <Divider
                            sx={{
                                backgroundColor: "#031851",
                            }}
                        />{}
                        <Grid
                            container
                            alignItems="center"
                            justifyContent="space-between"
                            spacing={2}
                            sx={{ paddingBottom: 1.5, paddingTop: 1.5 }}
                        >
                            <Grid item xs={3}>
                                <Typography variant="h4">{consult.description}</Typography>
                            </Grid>
                            <Grid item xs={2}>
                                <Typography variant="body1" sx={{ textAlign: "center" }}>
                                    {pricingAcc?.prospect?.prospect_id === "669580b61461f7cc543681dd" || pricingAcc?.prospect?.prospect_id === "66b18d9f1a7779f7a5be1fee" ? "Annually" : t(`proposals.oneTime2`)}
                                </Typography>
                            </Grid>
                            <Grid item xs={1} sx={{ textAlign: "center" }}>
                                <Typography variant="body1">{
                                    pricingAcc?.prospect_id === "66b18d9f1a7779f7a5be1fee" || pricingAcc?.prospect?.prospect_id === "66b18d9f1a7779f7a5be1fee" ? 1 : consult.hours
                                }</Typography>
                            </Grid>
                            <Grid item xs={1} sx={{ textAlign: "right" }}>
                                <Typography variant="body1">
                                    {pricingAcc?.prospect_id === "66b18d9f1a7779f7a5be1fee" || pricingAcc?.prospect?.prospect_id === "66b18d9f1a7779f7a5be1fee" ? "From" : "$" + parseFloat(pricingAcc.consulting.fee).toLocaleString(todos.amountFormat, {
                                        maximumFractionDigits: 2,
                                    })}
                                </Typography>
                            </Grid>
                            <Grid item xs={2} sx={{ textAlign: "right" }}>
                                <Typography variant="body1">
                                    {pricingAcc?.prospect_id === "66b18d9f1a7779f7a5be1fee" || pricingAcc?.prospect?.prospect_id === "66b18d9f1a7779f7a5be1fee" ? "$899" : "$" + parseFloat(pricingAcc.consulting.fee * consult.hours).toLocaleString(
                                        todos.amountFormat,
                                        {
                                            maximumFractionDigits: 2,
                                        }
                                    )}
                                </Typography>
                            </Grid>
                            <Grid item xs={1} sx={{ textAlign: "center" }}>
                                <Typography variant="body1">
                                    {parseFloat(consult.discount).toLocaleString(todos.amountFormat, {
                                        maximumFractionDigits: 2,
                                    })}
                                    %
                                </Typography>
                            </Grid>
                            <Grid item xs={2} sx={{ textAlign: "right" }}>
                                <Typography variant="body1">
                                    {pricingAcc?.prospect?.prospect_id === "669580b61461f7cc543681dd" || pricingAcc?.prospect?.prospect_id === "66b18d9f1a7779f7a5be1fee" ? "From $899" : "$" + parseFloat(
                                        pricingAcc.consulting.fee * consult.hours * (1 - consult.discount / 100)
                                    ).toLocaleString(todos.amountFormat, {
                                        maximumFractionDigits: 2,
                                    })}
                                </Typography>
                            </Grid>
                        </Grid>
                    </>
                ))}
        </StyledContainer>
    );
};
